import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FolderNavContext = /*#__PURE__*/createContext({
  isFolderNav: false
});
export const FolderNavContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(FolderNavContext.Provider, {
    value: props,
    children: children
  });
};
export const useFolderNavContext = () => {
  return useContext(FolderNavContext);
};